<div class="config-actions-bottom">
  <button mat-stroked-button color="primary" (click)="cancelConfig()">Back</button>
  <button mat-raised-button color="accent" (click)="saveConfig()">Save Configuration</button>
</div>

<div class="custom-recommendation-config">
  <div class="config-header">
    <h3>Custom Recommendation Configuration</h3>
  </div>

  <div *ngIf="loading" class="spinner-container">
    <mat-spinner></mat-spinner>
    <p>Loading activities from lessons...</p>
  </div>

  <div *ngIf="!loading">
    <div class="stars-header-row">

      <mat-accordion class="lessons-column" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header style="align-items: center;">
            <mat-panel-title>Lessons</mat-panel-title>
          </mat-expansion-panel-header>
      
          <div class="lesson-picker-list-vertical">
            <div *ngFor="let lesson of selectedLessons" class="lesson-list-item-vertical">
              <mat-checkbox
                color="primary"
                [checked]="selectedActivityLessons.includes(lesson.lessonId)"
                (change)="toggleLessonSelection(lesson.lessonId)">
                {{ lesson.displayName }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="stars-selection">
        <h4>Star Count:</h4>
        <mat-form-field appearance="outline" style="width: 120px; margin-top: 15px;">
          <mat-label>Stars</mat-label>
          <mat-select [value]="totalStars" (selectionChange)="selectTotalStars($event.value)">
            <mat-option *ngFor="let star of [1, 2, 3, 4]" [value]="star">{{ star }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="stars-paginator">
        <button mat-icon-button (click)="goToStar(currentStar - 1)" [disabled]="currentStar === 0">&lt;</button>
        <p>{{ currentStar + 1 }} of {{ totalStars }}</p>
        <button mat-icon-button (click)="goToStar(currentStar + 1)"
          [disabled]="currentStar === totalStars - 1">&gt;</button>
      </div>

      <div class="lives-column">
        <mat-form-field appearance="fill">
          <mat-label>Lives</mat-label>
          <input matInput type="number" [(ngModel)]="starConfigs[currentStar].life" min="1">
        </mat-form-field>
      </div>
    </div>

    <div class="star-configuration">
      

      <div class="content-row">
        <div class="activity-table-container">
          <mat-form-field appearance="standard">
            <mat-label>Filter Activities</mat-label>
            <input matInput (keyup)="applyActivityFilter($event)" placeholder="e.g. Activity x" #input>
          </mat-form-field>


          <div style="flex: 1; overflow-y: auto; min-height: 0;">
            <table mat-table [dataSource]="filteredActivitiesDataSource">
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let activity"> {{activity.description}} </td>
              </ng-container>
              <ng-container matColumnDef="text">
                <th mat-header-cell *matHeaderCellDef> Text </th>
                <td mat-cell *matCellDef="let activity"> {{activity.text}} </td>
              </ng-container>
              <ng-container matColumnDef="skill">
                <th mat-header-cell *matHeaderCellDef> Skill </th>
                <td mat-cell *matCellDef="let activity"> {{activity.skill}} </td>
              </ng-container>
              <ng-container matColumnDef="game">
                <th mat-header-cell *matHeaderCellDef> Game </th>
                <td mat-cell *matCellDef="let activity"> {{activity.game}} </td>
              </ng-container>
              <ng-container matColumnDef="lesson">
                <th mat-header-cell *matHeaderCellDef> Lesson </th>
                <td mat-cell *matCellDef="let activity"> {{activity.lessonName}} </td>
              </ng-container>
              <ng-container matColumnDef="pick">
                <th mat-header-cell *matHeaderCellDef> Select </th>
                <td mat-cell *matCellDef="let activity">
                  <button mat-mini-fab color="primary" [disabled]="isActivityPicked(currentStar, activity)"
                    (click)="addActivityToStar(currentStar, activity)">
                    <mat-icon>add</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="activitiesColumn"></tr>
              <tr mat-row *matRowDef="let myRowData; columns: activitiesColumn"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td [attr.colspan]="activitiesColumn.length"
                  style="text-align:center; color:#888; padding: 24px; font-size: 1.1em;">
                  No Lessons Selected
                </td>
              </tr>
            </table>
          </div>
          <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons #activitiesPaginator
            style="margin-top: 8px;">
          </mat-paginator>
        </div>

        <div class="activity-list-container">
          <h3>Selected Activities</h3>

          <!-- Wrap the draggable items -->
          <div cdkDropList (cdkDropListDropped)="dropActivity($event, currentStar)" class="activity-drop-list">
            <!-- Each activity row is draggable -->
            <div class="activity-row" *ngFor="let activity of starConfigs[currentStar].activities; let i = index"
              cdkDrag>
              <div class="activity-row-inner">
                <!-- Accordion -->
                <mat-accordion class="activity-accordion" multi>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header class="activity-panel-header">
                      <mat-panel-title>
                        <div class="header-left">
                          <div class="index-circle">{{ i + 1 }}</div>
                          <div class="title-text">
                            {{ getActivityDescription(activity.uid) }}
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <!-- Expanded content -->
                    <ng-container *ngIf="!isActivityInvalid(activity.uid, activity.lessonId)">
                      <div class="detail-line"><strong>Type:</strong> {{ getActivityDescription(activity.uid) }}</div>
                      <div class="detail-line"><strong>Vocabulary:</strong> {{ getActivityText(activity.uid) }}</div>
                      <div class="detail-line"><strong>Minigame:</strong> {{ getActivityGame(activity.uid) }}</div>
                      <div class="detail-line"><strong>Lesson:</strong> {{ getActivityLesson(activity.uid) }}</div>
                    </ng-container>
                  </mat-expansion-panel>
                </mat-accordion>

                <!-- Delete Button -->
                <div class="activity-remove">
                  <button mat-icon-button color="warn" (click)="removeActivityFromStar(currentStar, i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="rewards-list-container">
          <h3>Rewards</h3>
          <div class="list">
            <div class="list-item" *ngFor="let reward of starConfigs[currentStar].rewards; let rewardIndex = index">
              <div class="item-index">{{ rewardIndex + 1 }}</div>
              <div class="item-text">
                <mat-select [(value)]="reward.type"
                  (selectionChange)="onRarityChange(currentStar, reward.type, rewardIndex)">
                  <mat-option [value]="">Select Rarity</mat-option>
                  <mat-option *ngFor="let rarity of ChestRarity" [value]="rarity">
                    <img [src]="getRarityIcon(rarity)" class="rarity-icon">
                    <span class="option-text">{{ rarity }}</span>
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>